import {
    Component,
    OnInit,
    AfterViewInit,
    ViewChild,
    Renderer,
    ElementRef,
    OnDestroy
} from "@angular/core";
import {
    AlertController,
    App,
    Content,
    Events,
    Slides,
    LoadingController,
    NavController,
    NavParams,
    ToastController,
    ViewController
} from "ionic-angular";

import {LotteryService} from "../../services/lottery.services";
import {CommonService} from "../../services/common.service";
import {XocdiaService} from "../../services/xocdia.service";
import {AppDialog} from "../../component/appDialog";
import {LotteryHistoryPage} from "../lotteryHistory/lotteryHistory";
import {LotteryPage} from "../lottery/lottery";
import {RecordListPage} from "../recordList/recordList";
import { LoginPage } from "../login/login";
import { TranslateService } from "ng2-translate";
enum PlateBehavior {
    Open = 1,
    Xoc,
    Close,
    Ready,
}

const XOC_LO_TIME_ANIM = 2000;
const DIA_BAY_TIME_ANIM = 780;
const HIDE_CHIP_TIME_ANIM = 800;
const RECIEVE_MONEY_TIME_ANIM = 1200;
const TIMEOUT_REQUEST_API = 1000;
const TIMEOUT_REQUEST_MAX = 15;

// const MESSAGE_MAX_BET = "Giới hạn cược tối đa là ";
// const MESSAGE_MIN_BET = "Giới hạn cược tối thiểu là ";
// const MESSAGE_NOT_ENOUGH_MONEY = "Số dư hiện tại không đủ , vui lòng nạp thêm tiền";
// const MESSAGE_REPEAT_BET = "Chưa có dữ liệu cược trước đó";
// const MESSAGE_BET_FAIL = "Có lỗi xảy ra khi cược";

@Component({
    selector: "xoc-dia-page",
    templateUrl: "XocDiaPage.html"
})
export class XocDiaPage implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild(Content) content: Content;
    @ViewChild(Slides) slides: Slides;
    @ViewChild('iframeEmbed') iframeEmbed: ElementRef;

    public pageDome: HTMLElement;
    public betType: string = "";
    public xocBehavior: number = PlateBehavior.Close;
    public is1Giay: boolean = false;
    public gameNameTitle: string = '';
    public gameNameNote: string = '';
    public losewinmoney: any;
    public modelList: any = [];
    public getArrHistoryLimit: any = [];
    private listChip: any = [];
    private totalBetMoney: number;
    private isNeedBehavior: boolean = true;
    private prize: number;
    private gameId: number;
    private betPost: any;
    private balance: number;
    private newbalance: number;
    private nav: any;
    private isMuted: boolean = false;
    private openRecordPanelShow: boolean = false;
    private isHuyCuoc: boolean = false;
    private isTaiCuoc: boolean = false;
    private scrollTop: number = 0;
    // for 1 phut xocdia
    public currentIssue: string;
    public lastIssue: string;
    public winnumberArr: any;
    public countTime: string;
    static countTimer: any;
    public isShowSpinner: boolean = false;
    private requestCount = 0;
    private toggleHTimeResult: boolean = true;
    private coutTimeoutResult: any;
    private coutTimeResult: string = '00:00:00';
    public titleStoreBtn: string = '';

    public timeoutGetOpenWin = null;
    public timeoutRequestBalance = null;
    public timeoutAniBetWin = null;
    public timeoutRecieveMoneyTime01 = null;
    public timeoutRecieveMoneyTime02 = null;
    public timeoutGroupChip = null;
    public timeoutHideChip = null;
    public timeoutHideChip02 = null;
    public totalMoneyShow: number = 0;
    public selectedLanguage: string = 'vi';
    public strWinorLost: string = '-';

    public link_xoc = "build/assets/images/xocdia/xoc.png"
    public chipbetList: any = [
        {
            name: "",
            chipVal: "0",
            chipTitle: "0",
            status: "1",
            src: "build/assets/images/xocdia/chip1.png"
        },
        {
            name: "",
            chipVal: "0",
            chipTitle: "0",
            status: "0",
            src: "build/assets/images/xocdia/chip2.png"
        },
        {
            name: "",
            chipVal: "0",
            chipTitle: "0",
            status: "0",
            src: "build/assets/images/xocdia/chip3.png"
        },
        {
            name: "",
            chipVal: "0",
            chipTitle: "0",
            status: "0",
            src: "build/assets/images/xocdia/chip4.png"
        },
        {
            name: "",
            chipVal: "0",
            chipTitle: "0",
            status: "0",
            src: "build/assets/images/xocdia/chip5.png"
        },
        {
            name: "",
            chipVal: "0",
            chipTitle: "0",
            status: "0",
            src: "build/assets/images/xocdia/chip6.png"
        },
        {
            name: "",
            chipVal: "0",
            chipTitle: "0",
            status: "0",
            src: "build/assets/images/xocdia/chip7.png"
        },
        {
            name: "",
            chipVal: "0",
            chipTitle: "0",
            status: "0",
            src: "build/assets/images/xocdia/chip8.png"
        },
        {
            name: "",
            chipVal: "0",
            chipTitle: "0",
            status: "0",
            src: "build/assets/images/xocdia/chip9.png"
        }
    ];

    public xocdiaface = [];
    // [
    //     {
    //         name: "chẵn",
    //         methodname: "even",
    //         odds: "1:",
    //         gridCol: "col-6",
    //         src: `build/assets/images/${this.selectedLanguage}/xocdia/chan.png`
    //     },
    //     {
    //         name: "lẻ",
    //         methodname: "odd",
    //         odds: "1:",
    //         gridCol: "col-6",
    //         src: `build/assets/images/${this.selectedLanguage}/xocdia/le.png`
    //     },
    //     {
    //         name: "trắng",
    //         methodname: "white",
    //         odds: "1:",
    //         gridCol: "col-6",
    //         colors: [
    //             "bet-vi-color0",
    //             "bet-vi-color0",
    //             "bet-vi-color0",
    //             "bet-vi-color0"
    //         ]
    //     },
    //     {
    //         name: "đỏ",
    //         methodname: "red",
    //         odds: "1:",
    //         gridCol: "col-6",
    //         colors: [
    //             "bet-vi-color1",
    //             "bet-vi-color1",
    //             "bet-vi-color1",
    //             "bet-vi-color1"
    //         ]
    //     },
    //     {
    //         name: "batrắngmộtđỏ",
    //         methodname: "3white1red",
    //         odds: "1:",
    //         gridCol: "col-6",
    //         colors: [
    //             "bet-vi-color1",
    //             "bet-vi-color0",
    //             "bet-vi-color0",
    //             "bet-vi-color0"
    //         ]
    //     },
    //     {
    //         name: "mộttrắngbađỏ",
    //         methodname: "1white3red",
    //         odds: "1:",
    //         gridCol: "col-6",
    //         colors: [
    //             "bet-vi-color1",
    //             "bet-vi-color1",
    //             "bet-vi-color1",
    //             "bet-vi-color0"
    //         ]
    //     }
    // ];

    public commandList = [
        {
            name: "help",
            src: "build/assets/images/xocdia/help.png"
        },
        {
            name: "history",
            src: "build/assets/images/xocdia/history.png"
        },
        {
            name: "repeatbet",
            src: "build/assets/images/xocdia/repeatbet.png"
        },
        {
            name: "cancelbet",
            src: `build/assets/images/xocdia/cancelbet.png`
        }
    ];
    
    public TIME_TO_CLOSE = '00:00:08';
    public TIME_TO_XOC = '00:00:07';
    
    constructor(
        public navCtrl: NavController,
        private app: App,
        public navParams: NavParams,
        public renderer: Renderer,
        public viewCtrl: ViewController,
        private lotteryService: LotteryService,
        private xocdiaService: XocdiaService,
        private toastCtrl: ToastController,
        private alertCtrl: AlertController,
        private events: Events,
        private navController: NavController,
        public el: ElementRef,
        private common: CommonService,
        public loadingCtrl: LoadingController,
        private translate: TranslateService
    ) {
        this.pageDome = el.nativeElement;
        this.gameNameTitle = navParams.data['titleGame'];
        this.gameNameNote = navParams.data['title'];
        this.gameId = navParams.data["lotteryId"];
        LotteryPage.lotteryId = this.gameId;
        this.is1Giay = this.gameId == 90 ? true : false;
        this.nav = navController;   
        const storedLanguage = localStorage.getItem('langcode');
        if (storedLanguage) {
            this.selectedLanguage = storedLanguage;
        } else {
            this.selectedLanguage = 'vi'; // Mặc định là tiếng Anh nếu không có giá trị trong localStorage
        }

        this.link_xoc = "build/assets/images/"+this.selectedLanguage+"/xocdia/xoc.png"
        this.xocdiaface = [
            {
                name: "chẵn",
                methodname: "even",
                odds: "1:",
                gridCol: "col-6",
                src: `build/assets/images/${this.selectedLanguage}/xocdia/chan.png`
            },
            {
                name: "lẻ",
                methodname: "odd",
                odds: "1:",
                gridCol: "col-6",
                src: `build/assets/images/${this.selectedLanguage}/xocdia/le.png`
            },
            {
                name: "trắng",
                methodname: "white",
                odds: "1:",
                gridCol: "col-6",
                colors: [
                    "bet-vi-color0",
                    "bet-vi-color0",
                    "bet-vi-color0",
                    "bet-vi-color0"
                ]
            },
            {
                name: "đỏ",
                methodname: "red",
                odds: "1:",
                gridCol: "col-6",
                colors: [
                    "bet-vi-color1",
                    "bet-vi-color1",
                    "bet-vi-color1",
                    "bet-vi-color1"
                ]
            },
            {
                name: "batrắngmộtđỏ",
                methodname: "3white1red",
                odds: "1:",
                gridCol: "col-6",
                colors: [
                    "bet-vi-color1",
                    "bet-vi-color0",
                    "bet-vi-color0",
                    "bet-vi-color0"
                ]
            },
            {
                name: "mộttrắngbađỏ",
                methodname: "1white3red",
                odds: "1:",
                gridCol: "col-6",
                colors: [
                    "bet-vi-color1",
                    "bet-vi-color1",
                    "bet-vi-color1",
                    "bet-vi-color0"
                ]
            }
        ];
    }

    ngOnInit() {
        this.bindEvent();
        this.totalMoneyShow = 0;
        if (this.gameId == 90) {
            this.xocdiaService.initXocdia1s([], this).then(data => {
                if (data['msg'] === '') {
                    this.initData(data);
                }else {
                    AppDialog.alert({
                        alertCtrl: this.alertCtrl,
                        message: data['msg'],
                        callBack: () => {
                            let tabsRoot = this.app.getRootNav();
                            tabsRoot.pop();
                        }
                    });
                }
            }).catch(error => {
                console.log(error);
            });
        }
        else {
            this.xocdiaService.initXocdia1m([], this).then(data => {
                if (data['msg'] === '') {
                    this.initData(data);
                }else {
                    AppDialog.alert({
                        alertCtrl: this.alertCtrl,
                        message: 'Không lấy được dữ liệu. Vui lòng thử lại.',
                        callBack: () => {
                            let tabsRoot = this.app.getRootNav();
                            tabsRoot.pop();
                        }
                    });
                }
            }).catch(error => {
                console.log(error);
            });
        }

        this.content.ionScroll.subscribe((data) => {
            this.scrollTop = data.scrollTop;
        });
    }

    initData(data: any) {
        // init list chip
        let chips: any = JSON.parse(data["chips"]);
        console.log('chips',chips)
        // reset list chip
        let templist = [];
        chips.forEach(function (item, index) {
            // let chip_index = 0;
            // if(index > 8) {
            //     chip_index = 8;
            // }else{
            //     chip_index = index;
            // }
            item.name = "chip" + (index + 1);
            item.src = "build/assets/images/xocdia/" + item.name + ".png";
            templist.push(item);
        });
        this.chipbetList = templist;

        // init list model
        let model = data['model'];
        if (model.length !== this.xocdiaface.length) {
            AppDialog.toast({
                toastCtrl: this.toastCtrl,
                message: 'Model không hợp lệ!',
                fn: () => {
                    let tabsRoot = this.app.getRootNav();
                    tabsRoot.pop();
                }
            });
        }else {
            model = model.map((item, index) => {
                item['level1'] = Math.max(0, item['level1'] - 1).toString();    
                this.xocdiaface = this.xocdiaface.map(itemFace => {
                if (itemFace['methodname'] === item['methodname']) {
                        itemFace['odds'] += item['level1'];
                    }
                    return itemFace;
                });

                return {
                    level1: item['level1'],
                    levelnum: item['levelnum'],
                    maxbet: item['maxbet'],
                    methodname: item['methodname'],
                    currentBet: 0,
                    name: this.xocdiaface.find(itemFace => itemFace['methodname'] === item['methodname']).name
                };
            });
            this.modelList = model;
        }

        // init 1m
        if (!this.is1Giay) {
            this.currentIssue = data["curissue"]["issue"];
            let endtime = data["curissue"]["endtime"];
            let servertime = data["servertime"];
            let pourTime: number = (+new Date(endtime.replace(/-/g, "/")) - +new Date(servertime.replace(/-/g, "/"))) / 1000;
            if (pourTime < 0) {
                return;
            }
            this.setOpenTime(endtime, servertime, pourTime);
            this.getHistory1Phut();
        }

    }

    /**
     * listening event issues:go from page trace
     */
    bindEvent() {}

    ionViewWillLeave() {
        clearInterval(XocDiaPage.countTimer);
        clearTimeout(this.timeoutGetOpenWin);
        clearTimeout(this.timeoutRequestBalance);
    }

    ionViewWillEnter() {
        this.lotteryService.getBalance(data => {
            this.balance = data["balance"];
            this.updateBalance(true);
        });
    }


    ngAfterViewInit() {
        let taBarDom = this.navCtrl.parent._elementRef.nativeElement.querySelector(
            "div.tabbar"
        );
        let addDom = document.createElement("div");
        addDom.setAttribute("tappable", "");
        addDom.className = "hide";
        addDom.id = "lottery-submit";
        taBarDom.appendChild(addDom);
        taBarDom.setAttribute("hidden", true + "");
    }

    dismiss() {
        this.cancelbet(false);
        clearInterval(XocDiaPage.countTimer);
        clearTimeout(this.timeoutGetOpenWin);
        clearTimeout(this.timeoutRequestBalance);
        setTimeout(() => {
            let tabsRoot = this.app.getRootNav();
            tabsRoot.pop();
        }, 500);
    }

    ngOnDestroy() {
    }

    toggleSound() {
        this.isMuted = !this.isMuted;
    }

    toggleOpenRecordPanel() {
        this.openRecordPanelShow = !this.openRecordPanelShow;
    }

    audioMoChen(obj?: any) {
        let objData = obj || null;
        if (objData && objData.remove) {
            document.getElementById('ifrAudio').remove();
            return;
        }
        let src = 'build/assets/images/xocdia/audio/xocdiaopen.mp3', muted = false;
        let elIfr = document.createElement('iframe');
        elIfr.id = 'ifrAudio';
        elIfr.src = src;
        elIfr["allow"] = 'autoplay';
        elIfr.style.display = 'none';
        this.iframeEmbed.nativeElement.appendChild(elIfr);
    }

    audioTiengXoc(obj?: any) {
        let objData = obj || null;
        if (objData && objData.remove) {
            document.getElementById('ifrAudioTiengPhao').remove();
            return;
        }
        let src = 'build/assets/images/xocdia/audio/xocdia.mp3';
        let elIfr = document.createElement('iframe');
        elIfr.id = 'ifrAudioTiengPhao';
        elIfr.src = src;
        elIfr["allow"] = 'autoplay';
        elIfr.style.display = 'none';
        this.iframeEmbed.nativeElement.appendChild(elIfr);
    }

    setOpenTime(endtime: string, servertime: string, pourTime: number) {
        clearInterval(XocDiaPage.countTimer);
        XocDiaPage.countTimer = setInterval(() => {
            pourTime--;
            if (pourTime >= 0) {
                let hour: any = parseInt((pourTime / 3600).toString());
                let minute: any = parseInt(((pourTime - hour * 3600) / 60).toString());
                let second: any = parseInt((pourTime % 60).toString());
                if (hour < 10) {
                    hour = "0" + hour;
                }
                if (minute < 10) {
                    minute = "0" + minute;
                }
                if (second < 10) {
                    second = "0" + second;
                }
                this.countTime = hour + ":" + minute + ":" + second;
                if (this.countTime === this.TIME_TO_CLOSE) {
                    if (this.xocBehavior === PlateBehavior.Open) {
                        this.xoclodzolo();
                    }
                };
                if (this.countTime === this.TIME_TO_XOC && this.xocBehavior !== PlateBehavior.Xoc) {
                    if (this.xocBehavior === PlateBehavior.Open) {
                        this.xocBehavior = PlateBehavior.Close;
                    }
                    this.bet(event);
                };
            }
            if (pourTime === -1) {
                clearInterval(XocDiaPage.countTimer);
                this.goNextIusse1Phut();
            }
        }, 1000);
    }

    goNextIusse1Phut() {
        this.isShowSpinner = true;
        this.xocdiaService.initXocdia1m({}, null).then(data => {
            if (data) {
                let opentime = data["cursitem"]["opentime"];
                let endtime = data["cursitem"]["endtime"];
                let servertime = data["servertime"];
                let pourTime: number = (+new Date(endtime.replace(/-/g, "/")) - +new Date(servertime.replace(/-/g, "/"))) / 1000;
                if (pourTime < 0) {
                    this.goNextIusse1Phut();
                    return;
                }
                this.setOpenTime(endtime, servertime, pourTime);
                this.lastIssue = this.currentIssue;
                this.currentIssue = data["cursitem"]["issue"];

                this.requestCount = 0;
                this.getBetOpen(); // get result
            }
        }).catch(error => {
            console.log(error);
        });
    }

    getBetOpen() {
        let params = {
            flag: 'xocdia1mBetOpen',
            lotteryid: this.gameId,
            issue: this.lastIssue
        };

        this.xocdiaService.xocdia1mBetOpen(params, null).then(data => {
            if (data['data'].msg.trim().search('không tồn tại') >= 0) {
                this.timeoutGetOpenWin = setTimeout(() => {
                    this.requestCount++;
                    if (this.requestCount >= TIMEOUT_REQUEST_MAX) {
                        this.isShowSpinner = false;
                        this.xoclodzolo();
                        return;
                    }
                    this.getBetOpen();
                }, TIMEOUT_REQUEST_API)
            } else {
                if (this.xocBehavior === PlateBehavior.Ready) {
                    let getVi = data['data'].code[0].split("");
                    this.randomPosiVi(getVi);
                    this.xoclodzolo();
                    this.isShowSpinner = false;
                    this.lotteryService.getBalance(data => {
                        this.balance = data["balance"];
                        this.updateBalance(true);
                    });
                }
                else
                    this.isShowSpinner = false;

                this.timeoutRequestBalance = setTimeout(() => {
                    this.lotteryService.getBalance(data => {
                        this.balance = data["balance"];
                        this.updateBalance(true);
                    });
                }, TIMEOUT_REQUEST_API);

                this.getHistory1Phut();
            }
        }).catch(error => {
            console.log(error);
        });
    }

    getHistory1Phut() {
        // reset this.getArrHistoryLimit
        this.getArrHistoryLimit = [];

        let params = {
            sid: this.gameId,
            num: 20
        };
        this.xocdiaService.xocdiaHistoryTop(params, null).then(data => {
            let getData = data['data'];
            getData.map(item => {
                let objTemp = {};
                item.winnumber.split(',').length > 1 ? objTemp['detail'] = item.winnumber.split(',').sort() : objTemp['detail'] = item.winnumber.split('').sort();
                let winItem = objTemp['detail'];
                let totalDice = Number(winItem[0]) + Number(winItem[1]) + Number(winItem[2]);
                Number(winItem[0]) == Number(winItem[1]) && Number(winItem[0]) == Number(winItem[2]) ? (objTemp['daxiaoCls'] = "sign-baozi", objTemp['daxiaoText'] = "-", objTemp['danshuangCls'] = "sign-baozi", objTemp['danshuangText'] = "-") : (totalDice > 10 ? (objTemp['daxiaoCls'] = "sign-big", objTemp['daxiaoText'] = "T") : (objTemp['daxiaoCls'] = "sign-small", objTemp['daxiaoText'] = "X"), totalDice % 2 == 1 ? (objTemp['danshuangCls'] = "sign-odd", objTemp['danshuangText'] = "L") : (objTemp['danshuangCls'] = "sign-even", objTemp['danshuangText'] = "C"));
                objTemp['finishtime'] = item.issue;
                objTemp['winnumberarr'] = item.winnumberarr;
                this.getArrHistoryLimit.push(objTemp);
            });
        }).catch(error => {
            console.log(error);
        });
    }


    animBetWin(details: any) {
        details.forEach(item => {
            let betList = Array.from(document.querySelectorAll('[type=bet]'));
            betList.forEach(element => {
                if (element.getAttribute('value') === item) {
                    element.classList.add('activated');
                    this.timeoutAniBetWin = setTimeout(() => {
                        element.classList.remove('activated');
                    }, DIA_BAY_TIME_ANIM);
                }
            });
        });
    }

    updateBalance(init: boolean) {
        
        if (init) {
            this.convertBalance(this.balance);
            return;
        }
        let creditBar = document.querySelector('.creditsbar');
        creditBar.classList.add('receiveMoney');

        let losewin = document.querySelector('.moneyLostWin');
        losewin.classList.add('loseMoney');
        let prefix = '-';
        this.losewinmoney = prefix + this.common.numberWithCommas(this.totalBetMoney);

        this.timeoutRecieveMoneyTime01 = setTimeout(() => {
            creditBar.classList.remove('receiveMoney');
            losewin.classList.remove('loseMoney');
            if (this.prize > 0) {
                losewin.classList.add('winMoney');
                prefix = '+';
                this.losewinmoney = prefix + this.common.numberWithCommas(this.prize);
                this.timeoutRecieveMoneyTime02 = setTimeout(() => {
                    losewin.classList.remove('winMoney');
                    this.convertBalance(String(this.newbalance).replace(/,/g, ''));
                    this.balance = this.newbalance;
                }, RECIEVE_MONEY_TIME_ANIM);
            }
            else {
                this.convertBalance(String(this.newbalance).replace(/,/g, ''));
                this.balance = this.newbalance;
            }
        }, RECIEVE_MONEY_TIME_ANIM);
    }

    convertBalance(balance: any) {
      
        document.querySelector('.txtbalance').innerHTML = this.common.numberWithCommas(Number(balance));
    }

    goToSlide(number: any) {
        if (Math.abs(number - this.slides.getActiveIndex()) > 0)
            this.slides.slideTo(number, 0);
    }

    isValidBet(typeCheck: string, methodname: string = "", chipCurrency: Number = 0) {
        switch (typeCheck) {
            case 'MIN_BET': {
                let totalMoney = this.totalMoney();
                if (totalMoney == 0)
                    return this.translate.instant('XOCDIA.MESSAGE_MIN_BET') + '5,000';
                else if (totalMoney > this.balance)
                        return this.translate.instant('XOCDIA.MESSAGE_NOT_ENOUGH_MONEY');
                break;
            }
            case 'MAX_BET': {
                let currentModel = this.modelList.find(model => model.methodname === methodname);
                if (currentModel != null) {
                    if (currentModel.currentBet >= currentModel.maxbet) {
                        currentModel.currentBet = currentModel.maxbet;
                        return this.translate.instant('XOCDIA.MESSAGE_MAX_BET') + this.common.numberWithCommas(currentModel.maxbet);
                    }
                    else {
                        currentModel.currentBet += chipCurrency;
                    }
                }
                break;
            }
            case 'REPEAT_BET': {
                if (this.listChip.length == 0)
                    return this.translate.instant('XOCDIA.MESSAGE_REPEAT_BET');
                break;
            }
        }
        return "";
    }

    selectBet(event: any, name: string, methodname: string) {
        let indexChip = this.chipbetList.findIndex((chip) => chip.status == 1);
        let maxChip = 5;
        this.goToSlide(indexChip);

        let activeChip = this.pageDome.querySelector('.chipbetBtn.active');
        let chipCurrency = Number(activeChip.getAttribute('value')) ;
        // let chipCurrency = Number(activeChip.getAttribute('value')) * 1000;
        // console.log("vao selectBet");
        
        this.totalMoneyShow +=chipCurrency;
        let msg = this.isValidBet('MAX_BET', methodname, chipCurrency);

        if (msg) {
            AppDialog.toast({
                toastCtrl: this.toastCtrl,
                message: msg
            });
            return;
        }
        let parentDiv = document.querySelector('.wraperRow.row');
        let cloneChip = document.createElement('span');
        cloneChip.innerHTML = activeChip.innerHTML;
        console.log("activeChip.getBoundingClientRect()",activeChip.getBoundingClientRect());

        // const body = document.body;
        const body = document.getElementById("wrapper");
        // Get the bounding rectangle of the body
        const bodyRect = body.getBoundingClientRect();
    
        // Calculate the left distance from the body to the full screen
        const leftDistance = bodyRect.left;
        console.log("scrollTop",this.scrollTop);
        
        cloneChip.style.position = "absolute";
        cloneChip.style.top = (activeChip.getBoundingClientRect().top - activeChip.getBoundingClientRect().height + this.scrollTop) + 'px';
        cloneChip.style.left = activeChip.getBoundingClientRect().left-leftDistance + 'px';
        cloneChip.style.width = activeChip.getBoundingClientRect().width + 'px';
        cloneChip.style.height = activeChip.getBoundingClientRect().height + 'px';
        cloneChip.style.zIndex = "103";
        cloneChip.classList.add('chipbetBtn');
        cloneChip.classList.add('chipEmbed');
        cloneChip.classList.add(name);
        cloneChip.setAttribute('methodname', methodname);
        cloneChip.setAttribute('currency', chipCurrency.toString());
        parentDiv.appendChild(cloneChip);
        let ListCloneChips = document.querySelectorAll('.chipEmbed.' + name);
        let lastEl = <HTMLElement><any>ListCloneChips[ListCloneChips.length - 2];
        if (ListCloneChips.length > 1 && ListCloneChips.length < maxChip) {
            let getZIndexLastOld = Number(lastEl.style.zIndex) + 1;
            cloneChip.style.zIndex = "" + getZIndexLastOld + "";
        }
        else if (ListCloneChips.length >= maxChip) {
            let getZIndexLastOld = Number(lastEl.style.zIndex) + 1;
            cloneChip.style.zIndex = "" + getZIndexLastOld + "";
            this.groupChip(ListCloneChips);
        }

        let offset = ListCloneChips.length > maxChip ? maxChip : ListCloneChips.length;
        cloneChip.style.top = (event.currentTarget.getBoundingClientRect().top - activeChip.getBoundingClientRect().height + this.scrollTop - (offset * 4)) + 'px';
        cloneChip.style.left = event.currentTarget.getBoundingClientRect().left-leftDistance
            + (event.currentTarget.getBoundingClientRect().width / 2)
            - (Number(activeChip.getBoundingClientRect().width) / 2)
            + 'px';
    }

    groupChip(list: any) {
        let totalMoneyinChip = 0;
        this.timeoutGroupChip = setTimeout(() => {
            list.forEach(element => {
                let currentModel = this.modelList.find(model => model.methodname === element.getAttribute('methodname'));
                totalMoneyinChip += Number(element.getAttribute('currency'));
                totalMoneyinChip = totalMoneyinChip > currentModel.maxbet ? currentModel.maxbet : totalMoneyinChip;
                let titleShow = (totalMoneyinChip / 1000);
                element.querySelector('.txtbet').innerHTML = (totalMoneyinChip > 1000) ? titleShow+"K" : titleShow;
            });
        }, 310);
    }

    selectChip(event: any, item: any) {
        for (let chip of this.chipbetList) {
            if (chip.name === item.name) {
                chip.status = '1';
                continue;
            }
            chip.status = '0';
        }
    }

    selectCommand(event: any, command: any) {
        switch (command.name) {
            case "cancelbet": {
                this.cancelbet(false);
                break;
            }
            case "repeatbet": {
                this.repeatbet();
                break;
            }
            case "help": {
                this.instructionDialog();
                break;
            }
            case "history": {
                this.gotobetHistory();
                break;
            }
            default:
                break;
        }
    }

    saveAllChip() {
        this.cancelbet(true);
    }

    cancelbet(isSave: boolean) {
        console.log("cancelbet",isSave);
        this.totalMoneyShow = 0;
        if (this.isHuyCuoc)
            return;
        this.isHuyCuoc = true;

        const listChip = Array.from(document.querySelectorAll('.chipEmbed'));
        if (isSave)
            this.listChip = listChip;

        listChip.forEach(element => {
            element.classList.add('hideEffect');
        });
        this.timeoutHideChip = setTimeout(() => {
            listChip.forEach(element => {
                document.querySelector('.wraperRow.row').removeChild(element);
            });
            this.isHuyCuoc = false;
        }, HIDE_CHIP_TIME_ANIM);
        this.modelList.forEach(model => model.currentBet = 0);
    }

    repeatbet() {
        let msg = this.isValidBet('REPEAT_BET');
        if (msg) {
            AppDialog.toast({
                toastCtrl: this.toastCtrl,
                message: msg
            });
            return;
        }

        if (this.isTaiCuoc)
            return;
        this.isTaiCuoc = true;

        /// remove all current chip
        const listCurrentChip = Array.from(document.querySelectorAll('.chipEmbed'));
        listCurrentChip.forEach(element => {
            document.querySelector('.wraperRow.row').removeChild(element);
        });
        this.modelList.forEach(model => model.currentBet = 0);

        /// repeat chip
        this.totalMoneyShow = 0;
        this.listChip.forEach(element => {
            document.querySelector('.wraperRow.row').appendChild(element);
            element.classList.remove('hideEffect');
            element.classList.add('showEffect');
            let method = element.getAttribute('methodname');
            let currentBet = Number(element.getAttribute('currency'));
            this.totalMoneyShow +=currentBet;
            let currentModel = this.modelList.find(model => model.methodname === method);
            if (currentModel != null) {
                currentModel.currentBet += currentBet;
            }
        });

        this.timeoutHideChip02 = setTimeout(() => {
            this.listChip.forEach(element => {
                element.classList.remove('showEffect');
                this.isTaiCuoc = false;
            });
        }, HIDE_CHIP_TIME_ANIM);
    }

    totalMoney() {
        let total: number = 0;
        this.modelList.forEach(model => total += model.currentBet);
        return total;
    }

    betIssue() {
        let issueList: string = "";
        this.modelList.forEach(model => {
            if (model.currentBet > 0)
                issueList += "[" + model.name + "] : " + this.common.numberWithCommas(model.currentBet) + '' + '</br>';
        });
        return issueList;
    }

    bet(event: any) {
        if (this.isShowSpinner)
            return;

        if (this.xocBehavior === PlateBehavior.Ready) {
            let msg = this.isValidBet('MIN_BET');
            if (msg) {
                AppDialog.toast({
                    toastCtrl: this.toastCtrl,
                    message: msg
                });
                return;
            }
            this.betDialog(false);
            return;
        }
        if (this.isNeedBehavior)
            this.xoclodzolo();
    }

    submitBet() {
        // convert betdata object to betdata['..']
        for (let item in this.betPost.betdata) {
            let strTemp = "betdata[" + item + "]";
            let strTempVal = this.betPost.betdata[item];
            this.betPost[strTemp] = strTempVal;
            delete this.betPost.betdata[item];
        }
        delete this.betPost.betdata;
        // end convert betdata object to betdata['..']

        this.is1Giay ? this.bet1sService() : this.bet1mService();
    }
    loadBalance(timeOut : number) {
        setTimeout(() => {
            this.lotteryService.getBalance(data => {
                console.log("vao getBalance");
                
                let oldBalance= this.balance;
                this.balance = data["balance"];
                let newBalance = data["balance"];
           
                if (newBalance>oldBalance) {
                  let losewin = document.querySelector('.moneyLostWin');
                  losewin.classList.add('winMoney');
                  let prefix = '+';
                  const newB = this.common.numberWithCommas(newBalance - oldBalance); 
                  this.losewinmoney = prefix + newB;
                  this.timeoutRecieveMoneyTime02 = setTimeout(() => {
                      losewin.classList.remove('winMoney');
                      this.newbalance = newBalance;
                      console.log('this.newbalance',this.newbalance);
                      
                      this.convertBalance(this.newbalance);
                   
                  }, RECIEVE_MONEY_TIME_ANIM);

                } 
                this.updateBalance(true);
                
            });
        },timeOut);
    }

    xoclodzolo() {
        console.log("xoclodzolo", this.xocBehavior);
        
        if (this.xocBehavior === PlateBehavior.Close) {
            let plate = document.querySelector(".wrapperPlate");
            plate.classList.add("plateAnimation");

            this.isNeedBehavior = false;

            if (!this.isMuted)
                this.audioTiengXoc();

            setTimeout(() => {
                plate.classList.remove("plateAnimation");
                this.xocBehavior = PlateBehavior.Ready;
                this.isNeedBehavior = true;
                if (!this.isMuted)
                    this.audioTiengXoc({remove: true});

            }, XOC_LO_TIME_ANIM);
            this.xocBehavior = PlateBehavior.Xoc;
        }
        else if (this.xocBehavior === PlateBehavior.Ready) {
            console.log("Vao ready");
            
            let plateUp = document.querySelector(".plateUp");
            plateUp.classList.add("plateUpAnimation");
            this.isNeedBehavior = false;
            if (!this.isMuted)
                this.audioMoChen();

            setTimeout(() => {
                plateUp.classList.remove("plateUpAnimation");
                plateUp.classList.add("plateHide");
                this.xocBehavior = PlateBehavior.Open;
                if (this.is1Giay) {
                    // this.updateBalance(true);
                    this.loadBalance(1000);
                } else {
                    this.loadBalance(1000);
                    this.loadBalance(3000);
                    this.loadBalance(5000);  
                }
                this.isNeedBehavior = true;
                if (!this.isMuted)
                    this.audioMoChen({remove: true});
                setTimeout(() => {
                    // console.log("time out 1s");
                    let plateUp = document.querySelector(".plateUp");
                    plateUp.classList.add("plateDownAnimation");
                    plateUp.classList.remove("plateHide");
                    this.isNeedBehavior = false;
                    setTimeout(() => {
                        plateUp.classList.remove("plateDownAnimation");
                        this.xocBehavior = PlateBehavior.Close;
                        this.isNeedBehavior = true;
                    }, DIA_BAY_TIME_ANIM);  
                },5000);
            }, DIA_BAY_TIME_ANIM);
        }
        else if (this.xocBehavior === PlateBehavior.Open) {
            let plateUp = document.querySelector(".plateUp");
            plateUp.classList.add("plateDownAnimation");
            plateUp.classList.remove("plateHide");
            this.isNeedBehavior = false;
            setTimeout(() => {
                plateUp.classList.remove("plateDownAnimation");
                this.xocBehavior = PlateBehavior.Close;
                this.isNeedBehavior = true;
            }, DIA_BAY_TIME_ANIM);
        }
    }


    randomPosiVi(val: any) {
        let elWrapVi = document.getElementById('items-vi');
        let wBox = elWrapVi.offsetWidth;
        let radius = wBox / 2 - 30;
        let wVi = 25;
        let arrValColor = [];
        let listpos = [];
        let overlapping = false;

        elWrapVi.innerHTML = '';
        if (val && this.is1Giay) {
            arrValColor = val.split('|');
        } else if (val && !this.is1Giay) {
            arrValColor = val;
        }
        else {
            for (let i = 0; i < 4; i++) {
                arrValColor.push(this.getRandomInt(0, 1));
            }
        }

        while (listpos.length < 4) {
            let pos = {
                x: this.getXY(wVi / 2, radius).x,
                y: this.getXY(wVi / 2, radius).y
            };
            overlapping = false;

            for (var i = 0; i < listpos.length; i++) {
                var existing = listpos[i];
                if (Math.abs(existing.x - pos.x) < 20 && Math.abs(existing.y - pos.y) < 20) {
                    overlapping = true;
                    break;
                }
            }

            if (!overlapping) {
                listpos.push(pos);
            }
        }

        for (let i = 0; i < 4; i++) {
            let elVi = document.createElement('span');
            elVi.classList.add('vi');
            elVi.classList.add('bet-vi-color' + arrValColor[i]);
            elVi.style.width = wVi + 'px';
            elVi.style.height = wVi + 'px';
            elVi.style.top = listpos[i].y + 'px';
            elVi.style.left = listpos[i].x + 'px';
            elWrapVi.appendChild(elVi);
        }
    }

    getXY(toppingRadius, radiusPlate) {
        let posX, posY;
        do {
            posX = Math.floor(Math.random() * ((radiusPlate * 2) - 1));
            posY = Math.floor(Math.random() * ((radiusPlate * 2) - 1));
        } while (Math.sqrt(Math.pow(radiusPlate - posX, 2) + Math.pow(radiusPlate - posY, 2)) > radiusPlate - toppingRadius);

        return {x: posX, y: posY}
    }

    getRandomInt(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    setbetParam() {
        let data: { [name: string]: number } = {};
        this.modelList.forEach(item => {
            if (item.currentBet > 0) {
                data.hasOwnProperty(item.methodname) ? data[item.methodname] += item.currentBet : data[item.methodname] = item.currentBet;
            }
        });

        this.totalBetMoney = this.totalMoney();

        if (this.is1Giay) {
            this.betPost = {
                flag: 'xocdia1sBet',
                gameid: this.gameId,
                money: this.totalBetMoney,
                betdata: data
            };
            return this.totalBetMoney > 0;
        }
        else {
            this.betPost = {
                flag: 'xocdia1mBet',
                gameid: this.gameId,
                total_money: this.totalBetMoney,
                betdata: data,
                issue_start: this.currentIssue,
                "buyitem[]": "{'money':'" + this.totalBetMoney + "','nums':1,'times':'1'}",
            };
            return this.totalBetMoney > 0;
        }
    }

    bet1sService() {
        this.xocdiaService.xocdiaBet1s(this.betPost, this).then(data => {
            if (data['msg'] === '') {
                let result = JSON.parse(data['betresult']);
                this.saveAllChip();
                let getVi = result['data'].result;
                this.newbalance = result['data'].balance;
                // this.newbalance = this.loadBalance;
                this.updateBalance(false);
                // this.loadBalance(300);
                this.animBetWin(result['data'].details);
                this.prize = result['data'].prize;
                this.randomPosiVi(getVi);
                this.xoclodzolo();
                AppDialog.toast({
                    toastCtrl: this.toastCtrl,
                    message: result["msg"],
                });
            } else {

                AppDialog.toast({
                    toastCtrl: this.toastCtrl,
                    message: data["msg"]
                });
            }
        });
    }

    bet1mService() {
        this.xocdiaService.xocdiaBet1m(this.betPost, this).then(data => {
            if (data['msg'] === '') {
                if (data['betresult'] == "") {
                    AppDialog.toast({
                        toastCtrl: this.toastCtrl,
                        message: this.translate.instant('XOCDIA.MESSAGE_BET_FAIL')
                    });
                    return;
                }
                let result = JSON.parse(data['betresult']);
                this.newbalance = result['data'].balance;
                
                this.saveAllChip();
                this.prize = 0;
                this.updateBalance(false);
                AppDialog.toast({
                    toastCtrl: this.toastCtrl,
                    message: result["msg"],
                });
            } else {
                AppDialog.toast({
                    toastCtrl: this.toastCtrl,
                    message: data['msg']
                });
            }
        });
    }

    betDialog(repeat: boolean) {
        let totalText: any;
        let issue: string;
        let title: string;
        issue = this.betIssue().replace("mộttrắngbađỏ", "1xanh3đỏ").replace("batrắngmộtđỏ", "3xanh1đỏ");
        title = this.is1Giay ? this.translate.instant('XOCDIA.CONFIRM_BET') : this.translate.instant('XOCDIA.CONFIRM_BET_WITH_ISSUE',{issueTitle:issue});
        totalText = this.totalMoney();
        if (!this.setbetParam())
            return;
        let alertCmp = this.alertCtrl.create({
            title: title,
            cssClass: 'bet-dialog',
            message:
            '<div class="bet-info">' +
            '<div class="item-1">' + issue + '</div>' +
            '</div>' +
            '<div class="bet-num">' +
            '<table>' +
            '<tr><td>' + this.translate.instant('TOTAL_AMOUNT') + ':</td><td><span>' + this.common.numberWithCommas(+totalText) + '</span></td></tr>' +
            '</table>' +
            '</div>',
            buttons: [
                {
                    text: this.translate.instant('CANCEL'),
                },
                {
                    text: this.translate.instant('OK'),
                    handler: data => {
                        this.submitBet();
                    }
                }
            ]
        });
        alertCmp.present();
    }

    instructionDialog() {
        let title = this.translate.instant('HELP_GAME');

        let alertCmp = this.alertCtrl.create({
            title: title,
            cssClass: 'wrapperAlert',
            message:
            '<div id="xocdiaInfor" class="instruction-dialog" style="display:none;">' +
            '<div class="inner">' +
            '<div class="content">' +
            '<table>' +
            '<tr><th>'+this.translate.instant("HELP_GAME")+'</th><th>'+this.translate.instant("OANTUTI_PAGE.EXPLAIN")+'</th><th>'+this.translate.instant("OANTUTI_PAGE.EXAMPLE")+'</th></tr>' +
            '<tr><td>'+this.translate.instant("XOCDIA.EVEN")+'</td><td>'+this.translate.instant("XOCDIA.EVEN_DESCRIPTION")+'</td><td><p>'+this.translate.instant("XOCDIA.EVEN_EXAMPLE")+'</p>'+this.translate.instant("XOCDIA.EVEN_RESULT")+'</td></tr>' +
            '<tr><td>'+this.translate.instant("XOCDIA.ODD")+'</td><td>'+this.translate.instant("XOCDIA.ODD_DESCRIPTION")+'</td><td><p>'+this.translate.instant("XOCDIA.ODD_EXAMPLE")+'</p>'+this.translate.instant("XOCDIA.ODD_RESULT")+'</td></tr>' +
            '<tr><td>'+this.translate.instant("XOCDIA.FOUR_GREEN")+'</td><td>'+this.translate.instant("XOCDIA.FOUR_GREEN_DESCRIPTION")+'</td><td><p>'+this.translate.instant("XOCDIA.FOUR_GREEN_EXAMPLE")+'</p>'+this.translate.instant("XOCDIA.FOUR_GREEN_RESULT")+'</td></tr>' +
            '<tr><td>'+this.translate.instant("XOCDIA.FOUR_RED")+'</td><td>'+this.translate.instant("XOCDIA.FOUR_RED_DESCRIPTION")+'</td><td><p>'+this.translate.instant("XOCDIA.FOUR_RED_EXAMPLE")+'</p>'+this.translate.instant("XOCDIA.FOUR_RED_RESULT")+'</td></tr>' +
            '<tr><td>'+this.translate.instant("XOCDIA.THREE_GREEN_ONE_RED")+'</td><td>'+this.translate.instant("XOCDIA.THREE_GREEN_ONE_RED_DESCRIPTION")+'</td><td><p>'+this.translate.instant("XOCDIA.THREE_GREEN_ONE_RED_EXAMPLE")+'</p>'+this.translate.instant("XOCDIA.THREE_GREEN_ONE_RED_RESULT")+'</td></tr>' +
            '<tr><td>'+this.translate.instant("XOCDIA.ONE_GREEN_THREE_RED")+'</td><td>'+this.translate.instant("XOCDIA.ONE_GREEN_THREE_RED_DESCRIPTION")+'</td><td><p>'+this.translate.instant("XOCDIA.ONE_GREEN_THREE_RED_EXAMPLE")+'</p>'+this.translate.instant("XOCDIA.ONE_GREEN_THREE_RED_RESULT")+'</td></tr>' +
            '</table>' +
            '</div>' +
            '</div>' +
            '</div>',
            buttons: [
                {
                    text: this.translate.instant('OK')
                }
            ]
        });
        alertCmp.present();
    }

    gotobetHistory() {
        this.app.getRootNav().push(LotteryHistoryPage);
    }

    goRecordList() {
        let rootNav = this.app.getRootNav();
        if (RecordListPage.hasInit) {
            rootNav.pop();
        } else {
            rootNav.push(RecordListPage, {
                lotteryId: this.gameId,
                lotteryName: this.gameNameTitle
            });
        }
    }

        /**
     * @param elClass: class or id
     * @param {string} classEffect: add class effect
     * @param {number} timeoutSet: time out remove class effect
     */
    effectShowHideByClass(elClass: any, classEffect: string, timeoutSet: number) {
        let elMoneyBet = this.pageDome.querySelector(elClass);
        elMoneyBet.classList.add(classEffect);
        setTimeout(()=> {
            elMoneyBet.classList.remove(classEffect);
            this.strWinorLost = '-';
        },timeoutSet);
    }
}




// WEBPACK FOOTER //
// ./src/pages/XocDia/XocDiaPage.ts